import { Header } from 'components/slider/header';

import { ISlotReview } from 'constants/types';
import styles from './styles.module.css';
import { ReviewsMasonry } from 'components/reviews-masonry';
import { ReviewSlot } from 'components/cards/slot';
import { LoadMoreButton } from 'components/load-more-button';
import { useState } from 'react';

export const TableReviewSlot = ({
  data,
  count,
}: {
  data: ISlotReview[];
  count: number;
}) => {
  const [page, setPage] = useState(1);
  const pageLength = 4;

  if (!data?.length) {
    return null;
  }

  const visibleItems = page * pageLength;
  const visibleData = data.slice(0, visibleItems);
  const isShowMoreVisible = data.length > visibleItems;

  return (
    <section className={styles.reviews}>
      <div className={styles.container_s}>
        <Header hasIcon={false} name={'Last checks'} count={count} />
        <ReviewsMasonry gap="10px">
          {visibleData.map((item, index) => (
            <ReviewSlot
              data={item}
              slot={item.slot}
              casino={item.casino}
              key={item._id.toString() + index}
              isPublicProfile
              variant={'user'}
            />
          ))}
        </ReviewsMasonry>
      </div>
      {isShowMoreVisible && (
        <LoadMoreButton
          isAuto={false}
          isVisible={true}
          onClick={() => {
            setPage(Math.ceil(data.length / pageLength));
          }}
          variant={'transparent'}
          description="Load more"
          isFetching={false}
        />
      )}
    </section>
  );
};
